import { render, staticRenderFns } from "./ListExchangeRate.vue?vue&type=template&id=b8289fa8&"
import script from "./ListExchangeRate.vue?vue&type=script&lang=js&"
export * from "./ListExchangeRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListExchangeRate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports